export default __webpack_public_path__ + "static/media/criminal8.70807d73.jpg";